import { ComponentPropsWithoutRef } from 'react';
import { StyledButton } from './styles';

export const LinkButton = (props: ComponentPropsWithoutRef<'button'>) => <StyledButton {...props} />;
